import Vue from "vue";
import Router from "vue-router";
import home from "@/pages/home/home";
import index from "@/pages/index/index";
import search from "@/pages/search/search";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: home
    },
    {
      path: "/index",
      name: "index",
      component: index
    },
    {
      path: "/search",
      name: "search",
      component: search
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js